/**
 * Iconografía del sistema = Phosphor (decisión Martí 2026-09-01, sustituye
 * al set propio de trazo de F4). Las pantallas usan NOMBRES SEMÁNTICOS del
 * sistema (home, layers, inbox…); este mapa es el único sitio que sabe qué
 * glifo de Phosphor los dibuja — cambiar el set no toca ninguna pantalla.
 * Peso «regular» (≈ trazo 1.7 del set anterior). El tamaño lo da .sk-icon.
 */
import type { CSSProperties } from "react";
import {
  ArrowRight, Bell, BookOpen, Buildings, Camera, ChatCircleText, Compass, Database, Flask, Lightbulb, Seal, SealCheck, WarningCircle, CaretDown, CaretLeft, CaretRight, CaretUp, CreditCard, DeviceMobile, Envelope, File, FileText, Gear, House, Laptop, MagnifyingGlass, Microphone, MicrophoneSlash, NotePencil, Paperclip, Play, Plug, Plus, SignOut, SlidersHorizontal, Stack, Stop, Tray, UploadSimple, User, UsersThree, Wrench,
  type Icon as PhosphorIcon,
} from "@phosphor-icons/react";

export const ICON_MAP = {
  home: House,
  layers: Stack,
  book: BookOpen,
  tool: Wrench,
  building: Buildings,
  inbox: Tray,
  bell: Bell,
  doc: FileText,
  file: File,
  team: UsersThree,
  user: User,
  gear: Gear,
  out: SignOut,
  logout: SignOut,
  chevron: CaretDown,
  "chevron-d": CaretDown,
  "chevron-u": CaretUp,
  "chevron-l": CaretLeft,
  "chevron-r": CaretRight,
  plus: Plus,
  search: MagnifyingGlass,
  upload: UploadSimple,
  // la puerta y el composer del Despacho (F6): sobre, micrófono y envío
  mail: Envelope,
  mic: Microphone,
  send: ArrowRight,
  // la voz del Despacho (ola 1, 2026-09-29): escuchar una respuesta y el
  // micro sin permiso
  play: Play,
  stop: Stop,
  "mic-off": MicrophoneSlash,
  // el adjunto del composer (2026-10-06)
  clip: Paperclip,
  // la cuenta del Despacho (F6): las seis secciones de la modal
  sliders: SlidersHorizontal,
  devices: DeviceMobile,
  laptop: Laptop,
  plug: Plug,
  card: CreditCard,
  // «Sus fuentes» en pastillas (2026-10-26): método, ficha firmada y
  // pendiente, cifras (foto, fuente viva, demostración), lo hablado, el
  // criterio general y la biblioteca caída
  compass: Compass,
  "seal-check": SealCheck,
  seal: Seal,
  camera: Camera,
  database: Database,
  flask: Flask,
  chat: ChatCircleText,
  lightbulb: Lightbulb,
  warning: WarningCircle,
  // «Conversación nueva» en la cabecera del Despacho (2026-10-27)
  compose: NotePencil,
} as const satisfies Record<string, PhosphorIcon>;

export type IconName = keyof typeof ICON_MAP;

export function Icon({ name, style, className }: { name: IconName; style?: CSSProperties | undefined; className?: string | undefined }) {
  const Glyph = ICON_MAP[name];
  return (
    <span className={className ? `sk-icon ${className}` : "sk-icon"} data-icon={name} style={style}>
      <Glyph weight="regular" size="100%" aria-hidden="true" />
    </span>
  );
}
